// @flow

import React from 'react';

export type AnnotationStyles = 'DEFAULT' | 'SUCCESS' | 'ERROR' | 'INFO' | 'WARNING';

const ANNOTATION_STYLES: {
  [AnnotationStyles]: {
    backgroundColor: string,
    borderColor: string,
    iconColor: string,
    icon: string
  }
} = {
  DEFAULT: {
    backgroundColor: "gray",
    borderColor: "gray",
    iconColor: "dark-gray",
    icon: "sticky-note-o"
  },
  SUCCESS: {
    backgroundColor: "green",
    borderColor: "green",
    iconColor: "white",
    icon: "check"
  },
  ERROR: {
    backgroundColor: "red",
    borderColor: "red",
    iconColor: "white",
    icon: "times"
  },
  INFO: {
    backgroundColor: "blue",
    borderColor: "blue",
    iconColor: "white",
    icon: "info"
  },
  WARNING: {
    backgroundColor: "orange",
    borderColor: "orange",
    iconColor: "white",
    icon: "warning"
  }
};

type Props = {
  annotation: {
    style: AnnotationStyles,
    body: {
      html: ?string
    }
  }
};

export default class Annnotation extends React.PureComponent<Props> {
  render() {
    const { backgroundColor, borderColor, icon, iconColor } = ANNOTATION_STYLES[this.props.annotation.style];

    return (
      <div className={`rounded flex items-stretch border-${borderColor} border mb4`}>
        <div className={`bg-${backgroundColor} flex-none flex pt3`} style={{ width: 30 }}>
          <div className="center flex-auto">
            <i className={`fa fa-${icon} ${iconColor}`} />
          </div>
        </div>
        <div className="flex-auto">
          <div
            className="m3 annotation-body"
            dangerouslySetInnerHTML={{
              __html: (
                (this.props.annotation.body && this.props.annotation.body.html)
                  ? this.props.annotation.body.html
                  : ''
              )
            }}
          />
        </div>
      </div>
    );
  }
}
